export default "{\n    \"noOptions\": \"Aucune adresse trouvée\"\n}\n"